export default {
  SET_LIST_OUTLET (state, outlet) {
    state.listOutlet = outlet
    state.loading = false
  },
  SET_ALL_OUTLETS (state, outlet) {
    state.allOutlets = outlet
    state.loading = false
  },
  SET_LOADING_OUTLET (state, loading) {
    state.loading = loading
  }
}
